import React, {useEffect} from "react";
import { animateScroll as scroll } from 'react-scroll';


export default function Landing(){

useEffect(() => {
    scroll.scrollToTop();
  }, []);


    return(

<section id="landing" style={{minHeight : '100vh', fontFamily: 'Lora, serif', padding: '3em 0', color:'#fff'}}>
            <div className="container-fluid">
                <div className="row">
                    <div className="col-sm-4 center-block" style={{marginTop: '3em'}}>
                        <img className="img-rounded img-responsive center-block"
                            src="resources/img/laurentmontagner.jpg" alt="laurent montagner"
                            style={{border: 'ridge 3px white'}} />
                    </div>
                    <div className="col-sm-8 text-center" style={{marginTop: '3em'}}>
                        <div className="row">
                            <h1>
                                LAURENT MONTAGNER <br /> <br /> <br /> MAGNÉTISEUR
                            </h1>
                        </div>
                        <div className="row" id="reflexologie_text_accueil">
                            <p>RÉFLÉXOLOGIE PLANTAIRE</p>
                            <p>Faculté Libre de Médecine</p>
                            <p>Et Naturelle</p>
                            <p>d'ÉTHNOMÉDECINE</p>
                        </div>
                    </div>
                </div>
    
            </div>
        </section>

    )
}